import { twMerge } from 'tailwind-merge';
import cx from 'classnames';
import type { ComponentProps } from 'react';

import Button from './Button';

export default function LoadingButton({
  children,
  loading,
  buttonProps,
  classes,
}: {
  children: React.ReactNode;
  loading: boolean;
  buttonProps?: ComponentProps<typeof Button>['buttonProps'];
  classes?: ComponentProps<typeof Button>['classes'];
}) {
  return (
    <Button
      variant={'filled'}
      loading={loading}
      buttonProps={{
        ...buttonProps,
        disabled: loading,
        className: twMerge(buttonProps?.className, cx({ 'flex justify-center': loading })),
      }}
      loadingProps={{
        variant: 'dark',
      }}
      classes={classes}
    >
      {!loading ? children : ''}
    </Button>
  );
}
